<template>
    <div
        class="steps-item"
        :class="{ 'step-item-enable': isActive, 'step-item-disable': isDisable, 'step-item-fail': isFailed }"
        >
        <div class="steps-item-tail"></div>
        <div class="steps-item-icon" :class="{'processing': isProcessing}">
            <span v-if="isFailed" class="steps-icon">&#10005;</span>
            <span v-else class="steps-icon">{{ index }}</span>
        </div>
        <div class="steps-item-content">
            <div class="steps-item-title">
                {{ title }}
                <span v-if="subTitle">{{ subTitle }}</span>
            </div>
            <div class="steps-item-description">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
// import Vue from "vue";
// const { STEP_STATUS } = Vue.prototype.$constants
import { STEP_STATUS } from "@/mixins/constants"

export default {
  name: 'StatusStep',
  props: {
      index: String,
      title: String,
      status: String,
      isProcessing: Boolean,
      subTitle: String,
  },
  computed: {
      isActive: {
          cache: false,
          get() {
              return this.status === STEP_STATUS.ENABLED
          }
      },
      isDisable: {
          cache: false,
          get() {
              return this.status === STEP_STATUS.DISABLED
          }
      },
      isFailed: {
          cache: false,
          get() {
              return this.status === STEP_STATUS.FAILED
          }
      }
  }
}
</script>
<style lang="scss" scoped>
.steps-item {
    .steps-item-icon {
        position: relative;
    }

    .processing::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background-image: linear-gradient(-45deg,hsla(0,0%,100%,.4) 25%,rgba(0,0,0,0) 0,rgba(0,0,0,0) 50%,hsla(0,0%,100%,.4) 0,hsla(0,0%,100%,.4) 75%,rgba(0,0,0,0) 0,rgba(0,0,0,0));
        background-size: 50px 50px;
        animation: move 2s linear infinite;
        overflow: hidden;
        border-radius: 50%;
    }

    @keyframes move {
        0% {
            background-position: 0 0
        }

        to {
            background-position: 50px 50px
        }
    }

    .steps-item-content {
        .steps-item-title {
            font-weight: 600;
        }
    }
}
</style>
